import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { APIService } from '../apiservices/apiservices';
import {EcineServiceBaseDTO} from "../../providersdata/EcineServiceBaseDTO";

@Injectable()

export class ControleCienteProvider {
  private header=APIService.getHeader();
  itemret;

  constructor(public http: HttpClient) {
  }

  /**
   * Lista segmentos
   * @param params? parâmetros de filtro segmento
   * @returns
   */
  get(continuationToken = null,
  page = null): Promise<{ Item: EcineServiceBaseDTO<any>, erro: string }> {
    var me=this;
    this.header=APIService.getHeader();

    return new Promise((resolve, reject) => {

      let url = APIService.API_URL + 'controleciente';

      const uri = new URL(url);

      if (continuationToken) {
        uri.searchParams.set("continuationToken",continuationToken);
      }

      if(page)
      {
        uri.searchParams.set("page",page);
      }

      url = uri.toString();

      me.http.get(url,{headers:me.header})
        .subscribe((result: any) => {
          ////console.log(result);
          //resolve(result.json());
          var jsonData=result;

          if (jsonData.length!=0)
          {
            if (jsonData.status_ret!="NOK")
            {
                var datasuccess={
                  'Item':jsonData,
                  'erro':''
                }
                me.itemret=datasuccess;
            }
            else{
              var errodatavazio={
                'Item':null,
                'erro':'Erro na consulta do controle.'
              }
              me.itemret=errodatavazio;
            }

            //resolve(me.itemret);
          }
          else{
            var errodatavazio1={
              'Item':null,
              'erro':'Nenhum registro encontrado.'
            }
            me.itemret=errodatavazio1;
          }
          resolve(me.itemret);
        },
        (error) => {
          var msg="";
          if (error.status==401){
            msg=error.statusText;
          }
          else{
            msg=error.error;
          }
          let errojson =msg;

          var errochamada={
            'Item':null,
            'erro':errojson
          }
          me.itemret=errochamada;
          reject(me.itemret);

        });
    });
  }

  updateStatusControle(codigo,
  tipo,
  lido: boolean): Promise<{ Item: EcineServiceBaseDTO<any>, erro: string }> {
    var me=this;
    this.header=APIService.getHeader();

    return new Promise((resolve, reject) => {

      let url = APIService.API_URL + 'controleciente';
      //console.log(requestData);
      me.http.post(url, {},{headers:me.header, params: {codigo, lido: lido ? "1" : "0", tipo, operacao: "ciente"}})
        .subscribe((result: any) => {

          var jsonData=result;

          if (jsonData.length!=0)
          {
            if (jsonData.status_ret!="NOK")
            {
                var datasuccess={
                  'Item':jsonData,
                  'erro':''
                }
                me.itemret=datasuccess;
            }
            else{
              //console.log(jsonData.erro);
              var errodatavazio={
                'Item':null,
                'erro':'Erro na atualização do controle.'
              }
              me.itemret=errodatavazio;
            }

            resolve(me.itemret);
          }
          else{
            var errodatavazio1={
              'Item':null,
              'erro':'Não há consultas.'
            }
            me.itemret=errodatavazio1;
          }
        },
        (error) => {
          var msg="";
          if (error.status==401){
            msg=error.statusText;
          }
          else{
            msg=error.error;
          }
          let errojson =msg;

          var errochamada={
            'Item':null,
            'erro':errojson
          }
          me.itemret=errochamada;
          reject(me.itemret);

        });
    });
  }

}
